import React from 'react';

export interface Segment {
  percentage: number;
  color: string;
  label?: string;
}

interface MultiSegmentProgressBarProps {
  segments: Segment[];
  height?: number;
  borderRadius?: number;
}

const MultiSegmentProgressBar: React.FC<MultiSegmentProgressBarProps> = ({
  segments,
  height = 10,
  borderRadius = 8,
}) => (
  <div
    className="multi-progress-container"
    style={{ height: `${height}px`, borderRadius: `${borderRadius}px` }}
  >
    {segments?.map((segment, index) => (
      <div
        key={`segment-${index + 1}`}
        className="segment"
        style={{
          width: `${segment?.percentage}%`,
          backgroundColor: segment?.color,
          borderRadius:
            // eslint-disable-next-line no-nested-ternary
            index === 0
              ? `${borderRadius}px 0 0 ${borderRadius}px`
              : index === segments.length - 1
              ? `0 ${borderRadius}px ${borderRadius}px 0`
              : '0',
        }}
      />
    ))}
  </div>
);

export default MultiSegmentProgressBar;
